<!-- 新生短信验证 -->
<template>
    <el-dialog
        title="确认信息"
        :close-on-click-modal="false"
        :show-close="false"
        :visible.sync="showSMS"
        width="800px"
        center>
        <el-row>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="ruleForm.studentName" disabled placeholder="请输入姓名"></el-input>
                </el-form-item>
                <template v-if="!$strExistHostnameOnce(['hsnc'])">
                    <el-form-item label="身份证号" prop="uid">
                        <el-input v-model="ruleForm.studentIdCard" disabled placeholder="请输入身份证号"></el-input>
                    </el-form-item>
                </template>
                <template v-else>
                    <el-form-item label="学号"  prop="studentNo">
                        <el-input v-model="ruleForm.studentNo || studentInfo.studentNo || ''" disabled placeholder="请输入学号"></el-input>
                    </el-form-item>
                </template>
                <el-form-item label="手机号" prop="studentPhone">
                    <el-input v-model="ruleForm.studentPhone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="yzm" v-if="phoneNeedSendSms">
                    <el-input placeholder="请输入短信验证码" v-model="ruleForm.yzm" style="width: 300px;">
                      <el-button slot="append" v-if="setCode" :disabled="disabledBut" @click="getYzm">{{setCode}}</el-button>
                    </el-input>
                </el-form-item>
            </el-form>
        </el-row>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitInfo">确 认</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {ApiEncryption,isvalidPhone} from "../common/validate";
import {get, post} from '@/common/request';
export default {
    name: "newStudentSMS",
    props: {
    },
    data() {
        var isvalidPhoneInfo = (rule, value, callback) => {
            if (this.$isEmpty(value)) {
                callback(new Error('请输入手机号码'));
            } else if(!isvalidPhone(value)){
                callback(new Error('请输入正确的手机号码'));
            }else{
                callback();
            }
          };
        return {
            setCode: "获取验证码",
            showSMS:false,
            phoneNeedSendSms:true,
            ruleForm:{
                studentName:"",
                studentIdCard: "",
                studentPhone: "",
                yzm: ""
            },
            time:60, //短信验证码倒计时
            disabledBut:false,
            studentInfo:sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag()),
            rules: {
                studentPhone: [
                    {required: true,validator: isvalidPhoneInfo, trigger: 'blur'}
                ],
                yzm: [
                    {required: true,message: "请输入短信验证码",trigger: "change",},
                ]
            },
        };
    },
    mounted() {
        this.getStuNewVerifyPhoneOpenConfig();
    },
    methods: {
        getStuNewVerifyPhoneOpenConfig(){ //是否开启手机验证
            this.$store.dispatch("user/getStuNewVerifyPhoneOpenConfig").then((ret) => {
                if (ret.code == 0 && ret.data.stuNewVerifyPhoneOpenConfig && (ret.data.stuNewVerifyPhoneShowConfig == 1 || ret.data.stuNewVerifyPhoneShowConfig == 3)){ //开启短信验证 stuNewVerifyPhoneShowConfig： 1：首页显示 2：报到流程显示 3：都显示
                    this.getStudentVerifyData();
                    // this.getVerifyCodeIntervalTime();
                }
            }).catch((ret) => {

            });
        },
        getStudentVerifyData(){ //开启验证，获取学生手机号验证数据
            this.$store.dispatch("user/getStudentVerifyData",{verifyCodeEnum:"STUDENT_NEW"}).then((ret) => {
                if (ret.code == 0 && ret.data.verifyStatus == 2){ // 1：通过验证 2：待验证
                    this.ruleForm = ret.data;
                    this.showSMS = true; //显示短信验证
                    this.getVerifyStudentPhoneNeedSendSms();
                }
            }).catch((ret) => {

            });
        },
        getVerifyStudentPhoneNeedSendSms(){ //是否需要验证码才能确定
            this.$store.dispatch("user/getVerifyStudentPhoneNeedSendSms",{verifyCodeEnum:"STUDENT_NEW"}).then((ret) => {
                if (ret.code == 0){ // true：显示 false不显示
                    this.phoneNeedSendSms = ret.data;
                }
            }).catch((ret) => {

            });
        },
        getVerifyCodeIntervalTime(){ //获取短信验证码发送冷却时间
            this.$store.dispatch("user/getVerifyCodeIntervalTime",{verifyCodeEnum:"STUDENT_NEW"}).then((ret) => {
                if (ret.code == 0){ // 1：通过验证 2：待验证
                    this.time = ret.data / 1000 || 60;
                }
            }).catch((ret) => {

            });
        },
        // 获取短信验证码
        getYzm() {
            if(this.$isEmpty(this.ruleForm.studentPhone)){
                this.$message.warning('请输入手机号！');
                return;
            }
            //后台需传入的参数
            let data = {
                phone: this.ruleForm.studentPhone,
                verifyCodeEnum: "STUDENT_NEW"
            };
            let url = "/api/student/"+ApiEncryption() + "/sendVerifyCode.do";
            post(window.configs.API_ROOT + url,data).then((ret) => {
                if (ret.code == 0){
                    this.$message.success('发送成功！');
                    this.validateBtn();
                }else{
                    this.$message.error(ret.msg);
                }
            });
        },
        validateBtn() {
          //倒计时
          let time = this.time;
          let timer = setInterval(() => {
            if (time == 0) {
              clearInterval(timer);
              this.disabledBut = false;
              this.setCode = "发送验证码";
            } else {
              this.setCode = time + "秒后重试";
              this.disabledBut = true;
              time--;
            }
          }, 1000);
        },
        submitInfo(){ //提交短信验证
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    let param = {
                        verifyCodeEnum:"STUDENT_NEW",
                        phone:this.ruleForm.studentPhone,
                        code:this.ruleForm.yzm
                    }
                    this.$store.dispatch("user/verifyStudentPhone",param).then((ret) => {
                        if (ret.code == 0){
                            this.showSMS = false; //显示短信验证
                            this.$message.success('确认成功！');
                        }else{
                            this.$message.error(ret.msg);
                        }
                    }).catch((ret) => {

                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/newStudentSMS.vue